<div class="ion-page modalBody fixed" scrollY="true">
  <div class="modalInnerWrapper">


    <div *ngIf="event.meetingCat=='HR' && (country == 'UK' ||
    country == 'FR' ||
    country == 'CL' ||
    country == 'UY' ||
    country == 'AE' ||
    country == 'AR' ||
    country == 'BR' ||
    country == 'DEU' ||
    country == 'ES' ||
    country == 'FR' ||
    country == 'HK' ||
    country == 'IE' ||
    country == 'KR' ||
    country == 'MU' ||
    country == 'MX' ||
    country == 'OT' ||
    country == 'PE' ||
    country == 'SA' ||
    country == 'SG' ||
    country == 'US' ||
    country == 'VR' ||
    country == 'WO' ||
    country == 'ZA' ||
    country == 'CA' ||
    country == 'IN'
    )">

      <div class="header-box">
        <button (click)="dismiss()" type="link" class="close">
          <span class="icon icon-close"></span>
        </button>
        <div class="racer-info flex-row " style="align-items: flex-start;align-self: flex-start;padding-top: 0.5rem;">
          <div class="name">{{event.eventLabel}}</div> <br>
        </div>
  
        <div class="description">
          <small style="color: white;margin-top: 0px;text-align: left;">{{event.eventName}}</small>
          <small style="color: white;margin-top: 0px;">{{event.eventLocalDate}} &nbsp; {{event.eventTime}}</small><br>
  
          <span class="text">Track Type: <strong>{{metaData.eventMetaData.trackType}}</strong>
          </span>
          <span class="text going-popup">Going: <strong>{{metaData.eventMetaData.going}}</strong>
          </span>
          <span class="text">Trifecta: <strong>{{metaData.eventMetaData.trifecta}}</strong>
          </span>
          <span class="text">Race Type: <strong>{{metaData.eventMetaData.raceType}}</strong>
          </span>
          <span class="text">Handicap: <strong>{{metaData.eventMetaData.handicap}}</strong>
          </span>
          <span class="text">Max Runners: <strong>{{metaData.eventMetaData.maxrunners}}</strong>
          </span>
          <span class="text">Amount: <strong>{{metaData.eventMetaData.addedMoneyAmount}} {{metaData.eventMetaData.addedMoneyCurrency}}</strong>
          </span>
          <span class="text">Eligibility type: <strong>{{metaData.eventMetaData.eligibilty_type}}</strong>
          </span>
          <span class="text">Distance: <strong>{{metaData.eventMetaData.distance}}</strong>
          </span>
        </div>
      </div>

      <div class="modal-body">
        <div class="runner-comments">
          <h3 style="font-size:20px;">
            Last Winner
          </h3>
          <p class="text-black">Horse <strong>{{metaData.eventMetaData.lastWinnerHorse}}</strong></p>
          <p class="text-black">Price <strong>{{metaData.eventMetaData.lastWinnerHorsePrice}}</strong></p>
          <p class="text-black">Year <strong>{{metaData.eventMetaData.lastWinnerYear}} / {{metaData.eventMetaData.lastWinnerRan}}</strong></p>
          <p class="text-black">Weight <strong>{{metaData.eventMetaData.lastWinnerHorseWeightText}}</strong></p>
          <p class="text-black">Age <strong>{{metaData.eventMetaData.lastWinnerHorseAgeYears}}</strong></p>
          <p class="text-black">Trainer <strong>{{metaData.eventMetaData.lastWinnerHorseTrainerName}}</strong></p>
          <p class="text-black">Jockey <strong>{{metaData.eventMetaData.lastWinnerHorseJockeyName}}</strong></p>
        </div>
  
      </div>

        
    </div>







    <div *ngIf="event.meetingCat=='DG' && country == 'UK' ">

      <div class="header-box">
        <button (click)="dismiss()" type="link" class="close">
          <span class="icon icon-close"></span>
        </button>
        <div class="racer-info flex-row " style="align-items: flex-start;align-self: flex-start;padding-top: 0.5rem;">
          <div class="name">{{event.eventLabel}}</div> <br>
        </div>
  
        <div class="description">
          <small style="color: white;margin-top: 0px;text-align: left;">{{event.eventName}}</small>
          <small style="color: white;margin-top: 0px;">{{event.eventLocalDate}} &nbsp; {{event.eventTime}}</small><br>
  
          <span class="text">Type: <strong>{{metaData.eventMetaData.type}}</strong>
          </span>
          <span class="text going-popup">Class: <strong>{{metaData.eventMetaData.class}}</strong>
          </span>
          <span class="text">Distance: <strong>{{metaData.eventMetaData.distance}}</strong>
          </span>
          <span class="text">Handicap: <strong>{{metaData.eventMetaData.handicap}}</strong>
          </span>
        
        </div>
      </div>

      <div class="modal-body">
      </div>
   
    </div>








    <div *ngIf="event.meetingCat=='HR' && country == 'AU' ">

      <div class="header-box">
        <button (click)="dismiss()" type="link" class="close">
          <span class="icon icon-close"></span>
        </button>
        <div class="racer-info flex-row " style="align-items: flex-start;align-self: flex-start;padding-top: 0.5rem;">
          <div class="name">{{event.eventLabel}}</div> <br>
        </div>
  
        <div class="description">
          <small style="color: white;margin-top: 0px;text-align: left;">{{event.eventName}}</small>
          <small style="color: white;margin-top: 0px;">{{event.eventLocalDate}} &nbsp; {{event.eventTime}}</small><br>
  
          <span class="text">Number: <strong>{{metaData.eventMetaData.number}}</strong>
          </span>
          <span class="text going-popup">Type: <strong>{{metaData.eventMetaData.Type}}</strong>
          </span>
          <span class="text">Time: <strong>{{metaData.eventMetaData.Time}}</strong>
          </span>
          <span class="text">Distance: <strong>{{metaData.eventMetaData.Distance}}</strong>
          </span>
          <span class="text">Prize Money: <strong>{{metaData.eventMetaData.PrizeMoney}}</strong>
          </span>
          <span style="text-align: left;" class="text">Betting Forcast: <strong>{{metaData.eventMetaData.Betting_Forcast}}</strong>
          </span>
        
        </div>
      </div>

      <div class="modal-body">
      </div>
   
    </div>










    <div *ngIf="event.meetingCat=='HA' && country == 'AU' ">

      <div class="header-box">
        <button (click)="dismiss()" type="link" class="close">
          <span class="icon icon-close"></span>
        </button>
        <div class="racer-info flex-row " style="align-items: flex-start;align-self: flex-start;padding-top: 0.5rem;">
          <div class="name">{{event.eventLabel}}</div> <br>
        </div>
  
        <div class="description">
          <small style="color: white;margin-top: 0px;text-align: left;">{{event.eventName}}</small>
          <small style="color: white;margin-top: 0px;">{{event.eventLocalDate}} &nbsp; {{event.eventTime}}</small><br>
  
          <span class="text">Number: <strong>{{metaData.eventMetaData.number}}</strong>
          </span>
          <span class="text going-popup">Type: <strong>{{metaData.eventMetaData.Type}}</strong>
          </span>
          <span class="text">Time: <strong>{{metaData.eventMetaData.Time}}</strong>
          </span>
          <span class="text">Distance: <strong>{{metaData.eventMetaData.Distance}}</strong>
          </span>
          <span class="text">Prize Money: <strong>{{metaData.eventMetaData.Prize_Money}}</strong>
          </span>
          <span style="text-align: left;" class="text">Betting Forcast: <strong>{{metaData.eventMetaData.Betting_Forcast}}</strong>
          </span>
        
        </div>
      </div>

      <div class="modal-body">
      </div>
   
    </div>













    <div *ngIf="event.meetingCat=='DG' && country == 'AU' ">

      <div class="header-box">
        <button (click)="dismiss()" type="link" class="close">
          <span class="icon icon-close"></span>
        </button>
        <div class="racer-info flex-row " style="align-items: flex-start;align-self: flex-start;padding-top: 0.5rem;">
          <div class="name">{{event.eventLabel}}</div> <br>
        </div>
  
        <div class="description">
          <small style="color: white;margin-top: 0px;text-align: left;">{{event.eventName}}</small>
          <small style="color: white;margin-top: 0px;">{{event.eventLocalDate}} &nbsp; {{event.eventTime}}</small><br>
  
          <span class="text">RaceNo: <strong>{{metaData.eventMetaData.RaceNo}}</strong>
          </span>
          <span class="text going-popup">RaceName: <strong>{{metaData.eventMetaData.RaceName}}</strong>
          </span>
          <span class="text">RaceTime: <strong>{{metaData.eventMetaData.RaceTime}}</strong>
          </span>
          <span class="text">RaceDistance: <strong>{{metaData.eventMetaData.RaceDistance}}</strong>
          </span>
          
        
        </div>
      </div>

      <div class="modal-body">
      </div>
   
    </div>












    <div *ngIf="(metaData | json)=='{}' ">

      <div class="header-box">
        <button (click)="dismiss()" type="link" class="close">
          <span class="icon icon-close"></span>
        </button>
        <div class="racer-info flex-row " style="align-items: flex-start;align-self: flex-start;padding-top: 0.5rem;">
          <div class="name">{{event.eventLabel}}</div> <br>
        </div>
  
        <div class="description">
          <small style="color: white;margin-top: 0px;text-align: left;">{{event.eventName}}</small>
          <small style="color: white;margin-top: 0px;">{{event.eventLocalDate}} &nbsp; {{event.eventTime}}</small><br>
  
          <br><br><br>
          
          
        
        </div>
      </div>

      <div class="modal-body">
      </div>
   
    </div>

    


    










  </div>

</div>







<!-- <div class="ion-page modalBody" *ngIf="selectedCatStatus == 'UK Greyhounds'">

  <div class="modalInnerWrapperNew">

    <div class="header-box">

      <button (click)="dismiss()" type="link" class="close">
        <span class="icon icon-close"></span>
      </button>
      <div class="racer-info flex-row " style="align-items: flex-start;align-self: flex-start;padding-top: 0.5rem;">
        <div class="name">{{metaData.eventMetaData.eventLable}}</div> <br>
      </div>


      <div class="description">
        <small style="color: white;margin-top: 0px;text-align: left;">{{metaData.eventMetaData.eventName}}</small>
        <small style="color: white;margin-top: 0px;">{{metaData.eventMetaData.eventLocalDate}} &nbsp; {{metaData.eventMetaData.eventTime}}</small><br>

        <span class="text">Type <strong>{{metaData.eventMetaData.greyhound_type}}</strong>
        </span>
        <span class="text">Class <strong>{{metaData.eventMetaData.greyhound_class}}</strong>
        </span>
        <span class="text">Distance <strong>{{metaData.eventMetaData.greyhound_distance}}</strong>
        </span>
        <span class="text">Handicap <strong>{{metaData.eventMetaData.greyhound_handicap}}</strong>
        </span>

      </div>

    </div>
  </div> -->